import { Components } from '@mui/material/styles/components';
import { ControllerFormControlColor } from '../../palette';
import { ControllerFont } from '../../fonts';
import theme from '../../provider/controllerBaseTheme';

export const FormControlComponent: Components = {
  MuiFormControl: {
    defaultProps: {
      variant: 'outlined',
    },
    styleOverrides: {
      root: {
        //
        // mason styles
        //
        '& .MasonFormControlLabelRoot': {
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'space-between',
        },
        '& .MasonFormControlTopRightAdornment': {
          color: String(ControllerFormControlColor.TopRightAdornmentDefaultFg),
          '&-disabled': {
            color: String(ControllerFormControlColor.TopRightAdornmentDisabledFg),
            pointerEvents: 'none',
          },
        },
        //
        // MUI helper text overrides
        //
        '& .MuiFormHelperText-root': {
          color: String(ControllerFormControlColor.HelperTextDefaultFg),
          margin: theme.spacing(0.25, 0),
          ...ControllerFont.Text350R,
          '&.Mui-disabled': {
            color: String(ControllerFormControlColor.HelperTextDisabledFg),
          },
          '&.Mui-error': {
            color: String(ControllerFormControlColor.HelperTextErrorFg),
          },
          '&.Mui-focused': {
            color: String(ControllerFormControlColor.HelperTextFocusFg),
          },
          '&.Mui-required': {
            color: String(ControllerFormControlColor.HelperTextRequiredFg),
            '&.Mui-error': {
              color: String(ControllerFormControlColor.HelperTextErrorFg),
            },
          },
        },
      },
    },
  },
};
